import { Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LanguageSwitcher } from "@/components/i18n/LanguageSwitcher";
import { useI18n } from "@/lib/i18n";
import { markLoggedOut, redirectToKeycloakLogin } from "./oidc";
import { useEffect } from "react";

export function LoggedOutPage() {
  const { t } = useI18n();

  useEffect(() => {
    markLoggedOut();
  }, []);

  return (
    <div className="bg-muted/40 flex min-h-screen flex-col items-center justify-center p-4">
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>
      <div className="w-full max-w-sm rounded-lg border bg-white p-6 text-center shadow-sm dark:bg-neutral-950">
        <div className="mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded-md bg-neutral-100 dark:bg-neutral-900">
          <Shield className="h-5 w-5" aria-hidden="true" />
        </div>
        <h1 className="text-xl font-semibold">{t("logout.title")}</h1>
        <p className="text-muted-foreground mt-2 text-sm">
          {t("logout.description")}
        </p>
        <Button
          type="button"
          className="mt-5 w-full"
          onClick={() => {
            void redirectToKeycloakLogin(undefined, { prompt: "login" });
          }}
        >
          {t("login.keycloak")}
        </Button>
      </div>
    </div>
  );
}
